import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Backdrop } from '../../../primitives/Backdrop/index.js';
export const DialogBackdrop = /*#__PURE__*/_styled(props => {
  return _jsx(Backdrop, {
    ...props
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1p7v3u50"
} : {
  target: "e1p7v3u50",
  label: "DialogBackdrop"
})("z-index:", ({
  theme
}) => theme.stacking.zIndexOverlay, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtHIiwiZmlsZSI6IkJhY2tkcm9wLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJhY2tkcm9wIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9CYWNrZHJvcC9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgRGlhbG9nQmFja2Ryb3AgPSBzdHlsZWQoKHByb3BzKSA9PiB7XG4gICAgcmV0dXJuIF9qc3goQmFja2Ryb3AsIHsgLi4ucHJvcHMgfSk7XG59KSBgXG4gIHotaW5kZXg6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3RhY2tpbmcuekluZGV4T3ZlcmxheX07XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9QmFja2Ryb3AuanMubWFwIl19 */"));